import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Video, ArrowRight, Shield } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { meetApi } from './meetApi';
import MeetRoom from './MeetRoom';
import './MeetPage.css';
export default function JoinMeetPage() {
  const params = useParams();
  const {
    user
  } = useAuth();
  const [code, setCode] = useState(params.code || '');
  const [name, setName] = useState(user?.name || '');
  const [password, setPassword] = useState('');
  const [session, setSession] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  if (session) return <MeetRoom session={session} onExit={() => setSession(null)} />;
  return <div className="meet-app meet-join"><Link className="meet-brand" to="/meet"><Video /> Календарь <span>/ Встречи</span></Link><main className="meet-card meet-join-card"><div className="meet-icon"><Video size={28} /></div><h1>Вход во встречу</h1><form onSubmit={async e => {
        e.preventDefault();
        setBusy(true);
        setError('');
        try {
          if (!window.RTCPeerConnection || !window.isSecureContext) throw Error('Для звонка откройте страницу по HTTPS в современном браузере.');
          setSession((await meetApi.post('/join', {
            code: code.trim().toLowerCase(),
            password,
            name: name.trim()
          })).data);
        } catch (e) {
          setError(e.response?.data?.message || e.message || 'Не удалось войти.');
        } finally {
          setBusy(false);
        }
      }}><label>Ваше имя<input autoComplete="name" value={name} onChange={e => setName(e.target.value)} maxLength={60} required placeholder="Как к вам обращаться" /></label><label>Код встречи<input value={code} onChange={e => setCode(e.target.value)} maxLength={32} required placeholder="Код из приглашения" autoCapitalize="none" spellCheck={false} /></label><label>Пароль <small>если указан в приглашении</small><input type="password" autoComplete="off" value={password} onChange={e => setPassword(e.target.value)} maxLength={128} /></label>{error && <p role="alert" className="meet-error">{error}</p>}<button className="meet-primary" disabled={busy}>{busy ? 'Проверяем приглашение…' : 'Войти во встречу'} <ArrowRight size={18} /></button></form><div className="meet-privacy"><Shield size={18} /><span>Камера и микрофон выключены при входе. Вы сами решаете, когда их включить.</span></div></main></div>;
}
